import React from 'react';
import { CheckIcon, WrenchIcon, FlameIcon } from 'lucide-react';
import { ProductPack } from '../pack/ProductPack';
import { CtaButton } from '../CtaButton';
import { TrustLine } from '../TrustLine';
import { Pending } from '../Pending';
import { siteConfig } from '../../data/config';
import { formatPrice } from '../../utils/commerce';
const includes = ['6 professional diagnostic modules', '5 professional bonus resources', 'Visual diagnostic workflows', 'Fault-finding sequences', 'Diesel testing guides', 'Diagnostic decision trees', 'Professional workshop sheets'];
export function Offer() {
  const price = formatPrice();
  return <section id="offer" className="scroll-mt-4 bg-navy px-5 py-7 text-center text-white" data-id="element-122" data-mp="3jxmd1ibfylxf">
      <div className="mx-auto max-w-[520px]" data-id="element-123" data-mp="3nyy5dvlp9l9b">
        <p className="font-display text-[9px] uppercase tracking-[0.3em] text-gold" data-id="element-124" data-mp="3swpwwoifn5cz">
          {siteConfig.offerEyebrow || <Pending label="Offer eyebrow" data-id="element-125" data-mp="1qos2xp297zs" />}
        </p>
        <h2 className="mt-1 flex items-center justify-center gap-1.5 font-display text-[24px] uppercase leading-none md:text-[28px]" data-id="element-126" data-mp="1klglokytmeke">
          <WrenchIcon className="h-5 w-5 text-white" aria-hidden="true" data-id="element-127" data-mp="1fm3xnww7r1g8" /> Diesel Diagnostic Pro™
        </h2>
        <p className="mt-1 font-display text-[10px] uppercase tracking-[0.03em] text-white/85" data-id="element-128" data-mp="1blthxsimcwo6">
          The complete visual fault-finding system for diesel technicians
        </p>
        <div className="mt-2 flex justify-center" data-id="element-129" data-mp="23c7r5bfotkti">
          <ProductPack width={170} data-id="element-130" data-mp="23e2cgquvfey4" />
        </div>
        <div className="mx-auto mt-2 max-w-[450px] rounded-[4px] border-[2px] border-gold bg-white px-4 py-4 text-left text-ink" data-id="element-131" data-mp="1za4falp3we7p">
          <h3 className="text-center font-display text-[10px] uppercase tracking-[0.05em] text-navy" data-id="element-132" data-mp="1ui36j9r5d5mf">Complete 6-in-1 system</h3>
          <ul className="mt-2 grid gap-x-4 gap-y-1 sm:grid-cols-2" data-id="element-133" data-mp="1piqi4kkmnqhq">
            {includes.map(i => <li key={i} className="flex items-center gap-1.5 text-[10.5px]" data-id="element-134" data-mp="2i98k1i9m7ltk">
                <span className="flex h-3 w-3 shrink-0 items-center justify-center rounded-[2px] bg-ok" data-id="element-135" data-mp="2i75ka6inuebn">
                  <CheckIcon className="h-2 w-2 text-white" strokeWidth={4} aria-hidden="true" data-id="element-136" data-mp="317tkwefjrk4z" />
                </span>
                {i}
              </li>)}
          </ul>
          <p className="mt-3 flex flex-wrap items-center justify-center gap-1.5 text-center font-display text-[15px] text-navy" data-id="element-137" data-mp="2scx5331bn985">
            <FlameIcon className="h-4 w-4 text-[#F26B1D]" aria-hidden="true" data-id="element-138" data-mp="2iezgufjgpcfj" />
            Get DIESEL DIAGNOSTIC PRO™ Today
            {price ? <span className="rounded-[2px] bg-gold px-1.5 text-navy" data-id="element-139" data-mp="2nf3xq6oa896a">– {price}</span> : <Pending label="Price & currency" data-id="element-140" data-mp="29ekst8f45j8c" />}
          </p>
          <div className="mt-3 flex justify-center" data-id="element-141" data-mp="29ge10s5dkbig">
            <CtaButton className="max-w-none" data-id="element-142" data-mp="2df4qqe7igqvj">Get instant access</CtaButton>
          </div>
          {!siteConfig.checkoutUrl && <div className="mt-1.5 text-center" data-id="element-143" data-mp="7ng68qs1f8uv">
              <Pending label="Checkout link" data-id="element-144" data-mp="bp1neoblu9av" />
            </div>}
          <div className="mt-2" data-id="element-145" data-mp="bm726ukrokge">
            <TrustLine tone="light" data-id="element-146" data-mp="1w5sp4mzpji97" />
          </div>
        </div>
      </div>
    </section>;
}